import { useUserContext, PermissionType } from '../context/contexts/UserContext/UserContext';

const useHasPermissions = (permission: PermissionType) => {
    const { hasPermission } = useUserContext();
    return hasPermission(permission);
};

export default useHasPermissions;
